import { render, staticRenderFns } from "./tingliDec.vue?vue&type=template&id=22875677&scoped=true"
import script from "./tingliDec.vue?vue&type=script&lang=js"
export * from "./tingliDec.vue?vue&type=script&lang=js"
import style0 from "./tingliDec.vue?vue&type=style&index=0&id=22875677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22875677",
  null
  
)

export default component.exports